import React from 'react';
import { SearchNormal } from 'iconsax-react';

export const GlobalFilter = ( {filter, setFilter, placeholder} ) =>{
	return(
		<div className='sid-search'>
			<SearchNormal size={18} className='sid-search__icon' />
			<input
				className='sid-search__input'
				placeholder={placeholder || 'Cerca...'}
				value={filter || ''}
				onChange={e => setFilter(e.target.value)}
			/>
		</div>
	)
}
